import { Route, Routes } from 'react-router-dom';
import { Keyed } from '../../shared/components/Common';
import SightseeingSearch from './SightseeingSearch';
import SightseeingList from './SightseeingList';
import SightseeingDetails from './SightseeingDetails';
import SightseeingReview from './SightseeingReview';
import SightseeingConfirmation from './SightseeingConfirmation';
import SightseeingBookings from './SightseeingBookings';
import SightseeingBookingDetails from './SightseeingBookingDetails';

// Mounted at /sightseeing/*
export default function SightseeingRoutes() {
  return (
    <Routes>
      <Route index element={<SightseeingSearch />} />
      <Route path="results" element={<Keyed page={SightseeingList} />} />
      <Route path="review" element={<SightseeingReview />} />
      <Route path="confirmation/:bookingId" element={<SightseeingConfirmation />} />
      <Route path="bookings" element={<SightseeingBookings />} />
      <Route path="bookings/:bookingId" element={<SightseeingBookingDetails />} />
      <Route path=":activityId" element={<SightseeingDetails />} />
    </Routes>
  );
}
